<template>
  <div class="ivu-transfer">
    <div class="ivu-transfer-list">
      <div class="ivu-transfer-list-header">
        <span class="ivu-transfer-list-header-title">{{titles[0]}}</span>
        <span class="ivu-transfer-list-header-count">{{targetItems.length}}</span>
      </div>
      <div class="ivu-transfer-list-body">
        <ul class="ivu-transfer-list-content">
          <li v-for="(item, index) in targetItems" :key="`listItem-${item.key}-${index}`" @click="() => {changeTargetItems('remove', item, index)}" class="ivu-transfer-list-content-item">
            <span class="item-label">{{item.label}}</span>
          </li>
          <li class="ivu-transfer-list-content-not-found">列表为空</li>
        </ul>
      </div>
    </div>
    <div class="ivu-transfer-list">
      <div class="ivu-transfer-list-header">
        <span class="ivu-transfer-list-header-title">{{titles[1]}}</span>
      </div>
      <div class="ivu-transfer-list-body">
        <ul :class="['ivu-transfer-list-content', {'detail': itemType === 'detail'}]">
          <template v-if="itemType === 'normal'">
            <li v-for="(item, index) in data" :key="`listItem-${item.key}-${index}`" @click="() => {changeTargetItems('add', item, index)}" class="ivu-transfer-list-content-item">{{item.label}}</li>
          </template>
          <template v-else-if="itemType === 'detail'">
            <li v-for="(item, index) in data" :key="`listItem-${item.key}-${index}`" @click="() => {changeTargetItems('add', item, index)}" class="ivu-transfer-list-content-item">
              <span class="item-label">{{item.label}}</span>
              <div class="item-detail">
                <p v-for="(stepDetail, index) in item.stepDetail" :key="index">{{`${index+1}、${stepDetail}`}}</p>
              </div>
            </li>
          </template>  
          <li class="ivu-transfer-list-content-not-found">列表为空</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    titles: {
      type: Array,
      default: function() {
        return ['', ''];
      }
    },
    itemType: {
      type: String,
      default: function() {
        return 'normal'
      }
    },
    targetItems: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      operation: {
        add: 'add',
        remove: 'remove'
      }
    }
  },
  methods: {
    changeTargetItems(operation, item={}, index) {
      this.$emit('onChange', {operation, item, index})
    }
  }
}
</script>

<style lang="scss" scoped>
.ivu-transfer-list{
  margin-right: 80px;
  width: 400px;
  height: 500px;
}

.ivu-transfer .ivu-transfer-list:first-child .ivu-transfer-list-header{
  border: none;
  color: #fff;
  background-color: #19be6b;
}

.ivu-transfer .ivu-transfer-list:last-child .ivu-transfer-list-header{
  border: none;
  color: #fff;
  background-color: #2d8cf0;
}

.ivu-transfer-list-content.detail{
  padding: 0;
  .ivu-transfer-list-content-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    border-bottom: 1px solid #dddee1;
    .item-label{
      flex: 0 0 120px;
      padding: 12px 12px;
      width: 120px;
      text-align: center;
      white-space: normal;
    }
    .item-detail{
      flex: 1 1 auto;
      padding: 32px 0;
      border-left: 1px solid #dddee1;
      p{
        padding-left: 12px;
      }
    }
  }
}


</style>





// WEBPACK FOOTER //
// src/components/step-selector.vue